import {SERVICE_NAMES_BE} from '../../../../consts/rbac/rbac';

export default {
  SERVICES: [SERVICE_NAMES_BE.cms, SERVICE_NAMES_BE.maestro, SERVICE_NAMES_BE.mtms],
  VIEW_MODE: {
    GROUPS: 'Groups',
    ROLES: 'Roles'
  }
};
